import clsx from "clsx";
import { requestTypeTextColor } from "components/Card/RequestCard";
import Dialog from "components/Dialog";
import { EmptyList } from "components/PaginationList/Styles";
import { EmptyTableContent } from "components/Table/NothingDisplay";
import useText from "constants/text";
import { ItemAtPoint } from "contexts/RequestQuoteContext";
import { Address, EActionType, ERequestType } from "generated/graphql";
import React from "react";
import { ActionTypeLabel, TimelineDot } from "../RightSideComponents/TimeLineRequestPoint";
import { AddressStop, CardProductDetails, ContainerProductDetails, RecapStop } from "./CatalogStyles";
import ItemDetailsStop from "./ItemDetailsStop";
import { useStyles } from "./ListCatalogue";
interface IDialogDetailsStop {
  open: boolean;
  onClose: () => void;
  items: ItemAtPoint[];
  action: EActionType;
  address: Address;
  type: ERequestType;
}
export default function DialogDetailsStop({ open, onClose, items, action, address, type }: IDialogDetailsStop) {
  const { text } = useText();
  const styles = useStyles();
  const renderProducts = () =>
    items?.map((item) => (
      <CardProductDetails key={item?.product?._id}>
        <ItemDetailsStop product={item?.product} counter={item?.counter} requestType={type} />
      </CardProductDetails>
    ));

  const renderAddressPoint = () => (
    <TimelineDot
      style={{
        width: "14px",
        height: "14px",
        color: action === EActionType.Pickup && requestTypeTextColor[type],
        borderColor: requestTypeTextColor[type],
        backgroundColor:
          (action === EActionType.Delivery || action === EActionType.Unknown) && requestTypeTextColor[type],
      }}
      className={clsx(action === EActionType.Delivery || action === EActionType.Unknown ? "contained" : "outlined", {
        pickup: action === EActionType.Pickup,
        delivery: action === EActionType.Delivery || action === EActionType.Unknown,
      })}
    >
      {ActionTypeLabel[action] || "S"}
    </TimelineDot>
  );
  return (
    <Dialog
      title={text.catalog.articles}
      open={open}
      handleClose={onClose}
      cancelButtonTitle={text.all.close}
      maxWidth="lg"
      height="650px"
    >
      <RecapStop>
        {renderAddressPoint()}
        <AddressStop>{address?.address}</AddressStop>
      </RecapStop>
      {items?.length ? (
        <ContainerProductDetails className={styles.root}>{renderProducts()}</ContainerProductDetails>
      ) : (
        <EmptyList>
          <EmptyTableContent />
        </EmptyList>
      )}
    </Dialog>
  );
}
